import { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { DOUBLE_RIGHTCHEVRON, HOME_ICON } from '../assets/icons';

export let routes: { [x: string]: string } = {
  Home: '/',
  Profile: '/account',
  Settings: '/account/settings',
  'Transactions & Receipts': '/account/transactions',
  'My Requirements': '/requirements',
  'Find Tutor': '/find-tutor',
  'Post a Requirement': '/post-requirement',
  'My Messages': '/inbox'
};

export default function BreadCrumb() {
  const location = useLocation();
  const { id } = useParams();
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  const [breadcrumbNameMap, setBreadcrumbNameMap] = useState<{
    [x: string]: string;
  }>({});

  useEffect(() => {
    if (id) {
      routes = {
        ...routes,
        [id]: `/find-tutor/${id}`
      };
    }
  }, [id]);

  useEffect(() => {
    const temp: { [x: string]: string } = {};
    Object.keys(routes).forEach((route) => {
      temp[routes[route]] = route;
    });
    setBreadcrumbNameMap(temp);
  }, []);

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = decodeURI(`/${pathSnippets.slice(0, index + 1).join('/')}`);
    return (
      // <BreadcrumbItem key={url} url={url} name={breadcrumbNameMap[url]} />
      <BreadcrumbItem2 key={url}>
        <div className="flex gap-1.5 items-center">
          <img src={DOUBLE_RIGHTCHEVRON} className="w-3" alt="" />
          <Link to={url}>
            <p className="text-base text-primary/80">{breadcrumbNameMap[url]}</p>
          </Link>
        </div>
      </BreadcrumbItem2>
    );
  });

  const breadcrumbItems = [
    <BreadcrumbItem2 key={'/'}>
      <Link to={'/'}>
        <img src={HOME_ICON} className="w-4" alt="" />
      </Link>
    </BreadcrumbItem2>
  ].concat(extraBreadcrumbItems);

  return <div className="flex items-center gap-2">{breadcrumbItems}</div>;
}

function BreadcrumbItem2({ children }: { children: JSX.Element }) {
  return <>{children}</>;
}
